import { Injectable, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { identity, map, pickBy } from 'lodash';
import { catchError, of, take, tap } from 'rxjs';
import { SeoService } from './seo';
import { SharedService } from './shared.service';

@Injectable({ providedIn: 'root' })
export class GlobalSeoService {
  private meta = inject(Meta);
  private title = inject(Title);
  private seoService = inject(SeoService);
  private sharedService = inject(SharedService);

  initialize(pos: string) {
    return this.seoService
      .getMainPageSEOJSON(pos)
      .pipe(
        take(1),
        tap((res: any) => {
          if (res?.title) {
            this.title.setTitle(res.title);
          }

          this.clearExistingTags();
          
          this.sharedService.tags$ = [
            ...this.meta.addTags(map(res?.metas, (meta) => pickBy(meta, identity))),
            { charset: 'UTF-8' }
          ];
        }),
        catchError((error) => {
          console.error('SEO initialization failed:', error);
          this.setFallbackTags();
          return of(null);
        })
      );
  }

  private clearExistingTags(): void {
    ['description', 'og:title', 'og:description', 'og:image', 'twitter:card'].forEach(tag => {
      this.meta.removeTag(`name="${tag}"`);
      this.meta.removeTag(`property="${tag}"`);
    });
  }

  private setFallbackTags(): void {
    this.title.setTitle('Default Site Title');
    this.meta.addTags([
      { name: 'description', content: 'Default description' },
      { property: 'og:title', content: 'Default Site Title' },
      { property: 'og:description', content: 'Default description' }
    ]);
  }
}